import { combineReducers } from 'redux';
import appReducer from './appReducer';
import globalReducer from './global-ui';

const rootReducer = combineReducers({
  app: appReducer,
  global: globalReducer,
});

export default rootReducer;
